var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import kfetch from '@kareo/kfetch';
import styled from 'styled-components';
import { Alert, Box, Button, Card, CardContent, Checkbox, Divider, Radio, RadioGroup, TextField, ThemeProvider, } from '@kareo/design-system';
import { FeatureToggles, SecurityFooter } from '@kareo/billing-system';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import rollbar from 'shared-assets/src/errors/errors';
import { authenticatedUser } from 'shared-assets/lib/sdk/authenticatedUser';
import { FormControl, FormControlLabel, FormGroup, Typography, } from '@material-ui/core';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import FeatureToggle from 'shared-assets/components/FeatureToggle';
import { defaults } from 'shared-assets/lib/colors';
import CardDetailsSection from './CardDetailsSection';
import useTransactionSetupId from './useTransactionSetupId';
import CardDetailsContext from './CardDetailsContext';
import useSavedCards from './useSavedCards';
import portal from '../CardOnFile/portalConfig';
import featureToggles from '../../../lib/sdk/featureToggles';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-gap: 1rem;\n"], ["\n  display: grid;\n  grid-gap: 1rem;\n"])));
var BillingAddressForm = styled(Form)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-template-columns: 20rem 5rem;\n"], ["\n  grid-template-columns: 20rem 5rem;\n"])));
var ButtonWithBlueText = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: var(--primary-color-dark, ", ");\n"], ["\n  color: var(--primary-color-dark, ", ");\n"])), defaults.primaryColorDark);
var NoteTextArea = styled(TextField)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n\n  .MuiOutlinedInput-multiline {\n    padding: 0;\n  }\n"], ["\n  width: 100%;\n\n  .MuiOutlinedInput-multiline {\n    padding: 0;\n  }\n"])));
var CardDivider = styled(Divider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: 1px !important; // override .kareo hr\n"], ["\n  height: 1px !important; // override .kareo hr\n"])));
var Iframe = styled.iframe(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: none;\n  width: 100%;\n  height: 16rem;\n"], ["\n  border: none;\n  width: 100%;\n  height: 16rem;\n"])));
var FailedTransactionStatuses = new Set([
    'FAILED_CVV_CHECK',
    'FAILED_AVS_CHECK',
    'FAILED_VALIDATION',
    'FAILED',
]);
var formatAmount = function (pendingAmountToValidate) {
    var parsedAmount = Number(pendingAmountToValidate);
    if (isNaN(parsedAmount) ||
        pendingAmountToValidate.length === 0 ||
        parsedAmount < 0) {
        return '0.00';
    }
    return parsedAmount.toFixed(2);
};
export default function CollectPayment(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(FeatureToggle, { if: "!dark-feature.tebra-payfac-card-on-file" },
            React.createElement(CollectPaymentOld, __assign({}, props))),
        React.createElement(FeatureToggle, { if: "dark-feature.tebra-payfac-card-on-file" },
            React.createElement(CollectPaymentNew, __assign({}, props))),
        React.createElement(Box, { marginLeft: "auto", marginTop: 2 },
            React.createElement(SecurityFooter, null))));
}
function CollectPaymentOld(props) {
    var patient = props.patient, patientBalance = props.patientBalance, address1 = props.address1, zip = props.zip, onConfirmTransaction = props.onConfirmTransaction, onUpdateNote = props.onUpdateNote, onFinalizePayment = props.onFinalizePayment;
    var dsTheme = getDesignSystemTheme();
    var _a = useState(Number(patientBalance).toString()), amount = _a[0], setAmount = _a[1];
    var _b = useState(Number(patientBalance !== null && patientBalance !== void 0 ? patientBalance : 0).toFixed(2)), pendingAmount = _b[0], setPendingAmount = _b[1];
    var _c = useState('credit'), selectedPaymentMethod = _c[0], setSelectedPaymentMethod = _c[1];
    var _d = useState(false), preventCreditCharge = _d[0], setPreventCreditCharge = _d[1];
    var _e = useState(''), note = _e[0], setNote = _e[1];
    var _f = useState(false), showingNote = _f[0], setShowingNote = _f[1];
    var _g = useState(true), billingAddressSameAsPatientAddress = _g[0], setBillingAddressSameAsPatientAddress = _g[1];
    var _h = useState(address1), billingAddress1 = _h[0], setBillingAddress1 = _h[1];
    var _j = useState(zip), billingZip = _j[0], setBillingZip = _j[1];
    var _k = useState(props.name), name = _k[0], setName = _k[1];
    var handleChangePaymentMethod = useCallback(function (event) {
        setSelectedPaymentMethod(event.target.value);
        if (event.target.value !== 'credit') {
            setPreventCreditCharge(true);
        }
    }, [setSelectedPaymentMethod]);
    var handleChangePreventCreditCharge = useCallback(function (event) {
        setPreventCreditCharge(event.target.checked);
    }, [setPreventCreditCharge]);
    var resetBillingAddress = useCallback(function () {
        setBillingAddressSameAsPatientAddress(true);
        setBillingAddress1(address1);
        setBillingZip(zip);
        setName(name);
    }, [address1, zip, name]);
    var handleChangeBillingAddressSame = useCallback(function (event) {
        var checked = event.target.checked;
        if (checked) {
            resetBillingAddress();
        }
        setBillingAddressSameAsPatientAddress(checked);
    }, [setBillingAddressSameAsPatientAddress, resetBillingAddress]);
    var options = useMemo(function () {
        var address = typeof billingAddress1 === 'string' ? billingAddress1 : '';
        var zip = typeof billingZip === 'string' ? billingZip : '';
        var charge = typeof amount === 'string' ? amount : '0.00';
        return {
            amount: formatAmount(charge),
            name: name !== null && name !== void 0 ? name : '',
            billingAddress1: address !== null && address !== void 0 ? address : '',
            billingZipcode: zip !== null && zip !== void 0 ? zip : '',
            cardAccountId: patient.patientId,
        };
    }, [amount, billingAddress1, billingZip]);
    var _l = useTransactionSetupId(options), transactionSetupId = _l.transactionSetupId, firstLoad = _l.firstLoad;
    useEffect(function () {
        window.addEventListener('message', function (event) {
            if (event.origin.match(/api-payments-svcs.cloud.tebra.com/i) !== null) {
                //= == payFacUrl) {
                onConfirmTransaction(event.data);
            }
        });
    }, []);
    return (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(Card, null,
            React.createElement(CardContent, null,
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "h3" }, "Collect Payment"),
                    React.createElement(Form, { noValidate: true, autoComplete: "off" },
                        React.createElement(Box, { display: "block" },
                            React.createElement(TextField, { value: pendingAmount, label: "Amount", type: "text", margin: "dense", inputProps: {
                                    inputMode: 'decimal',
                                }, onChange: function (e) {
                                    setPendingAmount(e.target.value);
                                }, onBlur: function () {
                                    var newAmount = formatAmount(pendingAmount);
                                    setPendingAmount(newAmount);
                                    setAmount(newAmount);
                                } })),
                        React.createElement(Box, { display: "block" },
                            !showingNote && (React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () { return setShowingNote(true); } }, "Add Payment Note")),
                            showingNote && (React.createElement(Box, null,
                                React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start" },
                                    React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () {
                                            onUpdateNote('');
                                            setShowingNote(false);
                                        } }, "Remove Note"),
                                    React.createElement(NoteTextArea, { multiline: true, value: note, onChange: function (event) {
                                            var value = event.target.value;
                                            setNote(value);
                                            onUpdateNote(value);
                                        } }),
                                    React.createElement(Typography, { variant: "caption" }, "This note is only visible to the practice.")))))))),
            React.createElement(CardDivider, null),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h3" }, "Payment Method"),
                React.createElement(FormControl, { component: "fieldset" },
                    React.createElement(RadioGroup, { row: true, "aria-label": "selected-payment-method", name: "selectedPaymentMethod", value: selectedPaymentMethod, onChange: handleChangePaymentMethod },
                        React.createElement(FormControlLabel, { labelPlacement: "end", value: "credit", control: React.createElement(Radio, null), label: "Credit Card" }),
                        React.createElement(FormControlLabel, { labelPlacement: "end", value: "cash", control: React.createElement(Radio, null), label: "Cash" }),
                        React.createElement(FormControlLabel, { labelPlacement: "end", value: "check", control: React.createElement(Radio, null), label: "Check" })),
                    selectedPaymentMethod === 'credit' && (React.createElement(React.Fragment, null,
                        React.createElement(FormGroup, null,
                            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: preventCreditCharge, onChange: handleChangePreventCreditCharge }), label: "Do not charge credit card. For recording purposes only." })))))),
            React.createElement(CardDivider, null),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h3" }, "Billing Address"),
                React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: billingAddressSameAsPatientAddress, onChange: handleChangeBillingAddressSame }), label: "Billing address is same as patient address" })),
                    !billingAddressSameAsPatientAddress && (React.createElement(BillingAddressForm, null,
                        React.createElement(TextField, { margin: "dense", label: "Address", defaultValue: address1 }),
                        React.createElement(TextField, { margin: "dense", label: "Zip", defaultValue: zip, inputProps: { maxLength: 5 } }))))),
            React.createElement(CardDivider, null),
            !preventCreditCharge && firstLoad && (React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h3" }, "Card Details"),
                React.createElement(Box, null,
                    React.createElement(Iframe, { title: "Payment", height: "750rem", width: "100%", src: "" + transactionSetupId })))),
            preventCreditCharge && (React.createElement(React.Fragment, null,
                React.createElement(CardContent, null,
                    React.createElement(Box, null,
                        React.createElement(Button, { color: "vitality", disabled: !amount, onClick: function () {
                                return onFinalizePayment({
                                    amount: amount.toString(),
                                    paymentMethod: selectedPaymentMethod,
                                    note: note,
                                });
                            } }, "Finalize Payment"))))))));
}
// TODO: this is cool but caching not in requirements
// and makes it so we have to do this in multiple places,
// we'll either have to make this applicable everywhere or remove it.
// tbd during processing implementation
var PAY_FAC_SELECTED_TERMINAL_KEY = 'payfac-selected-terminal';
var selectedTerminalLocalStorage = localStorage.getItem(PAY_FAC_SELECTED_TERMINAL_KEY);
var defaultSelectedTerminal;
try {
    defaultSelectedTerminal =
        selectedTerminalLocalStorage && JSON.parse(selectedTerminalLocalStorage);
}
catch (e) {
    defaultSelectedTerminal = null;
}
function CollectPaymentNew(props) {
    var onConfirmTransaction = props.onConfirmTransaction, patient = props.patient, practice = props.practice;
    var dsTheme = getDesignSystemTheme();
    var _a = useSavedCards({
        patientId: patient.patientId,
    }), cards = _a.cards, isCardListFetching = _a.isLoading;
    var _b = useState(null), selectedCard = _b[0], _setSelectedCard = _b[1];
    function setSelectedCard(card) {
        _setSelectedCard(card);
        if (card !== null) {
            _setIsUsingTerminalPayOption(false);
        }
    }
    var _c = useState(false), isUsingTerminalPayOption = _c[0], _setIsUsingTerminalPayOption = _c[1];
    function setIsUsingTerminalPayOption(enabled) {
        _setIsUsingTerminalPayOption(enabled);
        if (enabled) {
            _setSelectedCard(null);
        }
        if (!enabled) {
            _setSelectedTerminal(null);
        }
    }
    var _d = useState(defaultSelectedTerminal), selectedTerminal = _d[0], _setSelectedTerminal = _d[1];
    var setSelectedTerminal = function (t) {
        _setSelectedTerminal(t);
        if (localStorage) {
            localStorage.setItem(PAY_FAC_SELECTED_TERMINAL_KEY, JSON.stringify(t));
        }
    };
    var _e = useState({ userGuid: '' }), user = _e[0], setUser = _e[1];
    var _f = useState(), error = _f[0], setError = _f[1];
    useEffect(function () {
        authenticatedUser.getAuthenticatedUser().then(function (resp) {
            setUser(resp);
        });
    }, []);
    useEffect(function () {
        window.addEventListener('message', function (event) {
            if (event.origin.match(/api-payments-svcs.cloud.tebra.com/i) === null) {
                return;
            }
            var response = event.data.response;
            var errorObj = response.error;
            var status = response.status;
            // check if status is any of the failure statuses
            var respStatus = status.toUpperCase();
            if (!FailedTransactionStatuses.has(respStatus)) {
                onConfirmTransaction(event.data);
                setError(undefined);
                return;
            }
            // if it is, set the error message
            var errorMessage = errorObj === null || errorObj === void 0 ? void 0 : errorObj.message;
            var hasMessage = errorMessage !== '' && errorMessage !== undefined;
            setError(new Error(hasMessage
                ? errorMessage
                : 'Card Declined: Invalid Credit Card Information. Please check the billing address and/or credit card information.'));
        });
    }, []);
    return (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(CardDetailsContext.Provider, { value: {
                patient: patient,
                practice: practice,
                user: user,
                cards: cards,
                isCardListFetching: isCardListFetching,
                selectedCard: selectedCard,
                setSelectedCard: setSelectedCard,
                error: error,
                setError: setError,
                selectedTerminal: selectedTerminal,
                setSelectedTerminal: setSelectedTerminal,
                isUsingTerminalPayOption: isUsingTerminalPayOption,
                setIsUsingTerminalPayOption: setIsUsingTerminalPayOption,
            } },
            React.createElement(CollectPaymentComponent, __assign({}, props)))));
}
function CollectPaymentComponent(props) {
    var patient = props.patient, patientBalance = props.patientBalance, address1 = props.address1, zip = props.zip, onUpdateNote = props.onUpdateNote, onFinalizePayment = props.onFinalizePayment;
    var _a = useContext(CardDetailsContext), selectedCard = _a.selectedCard, selectedTerminal = _a.selectedTerminal, practice = _a.practice, user = _a.user, error = _a.error, setError = _a.setError;
    var _b = useState(Number(patientBalance).toString()), amount = _b[0], setAmount = _b[1];
    var _c = useState(Number(patientBalance !== null && patientBalance !== void 0 ? patientBalance : 0).toFixed(2)), pendingAmount = _c[0], setPendingAmount = _c[1];
    var _d = useState('credit'), selectedPaymentMethod = _d[0], setSelectedPaymentMethod = _d[1];
    var _e = useState(false), preventCreditCharge = _e[0], setPreventCreditCharge = _e[1];
    var _f = useState(''), note = _f[0], setNote = _f[1];
    var _g = useState(false), showingNote = _g[0], setShowingNote = _g[1];
    var _h = useState(true), billingAddressSameAsPatientAddress = _h[0], setBillingAddressSameAsPatientAddress = _h[1];
    var _j = useState(address1), billingAddress1 = _j[0], setBillingAddress1 = _j[1];
    var _k = useState(zip), billingZip = _k[0], setBillingZip = _k[1];
    var _l = useState(props.name), name = _l[0], setName = _l[1];
    var _m = useState(false), isCheckedSaveCard = _m[0], setIsCheckedSaveCard = _m[1];
    var _o = useState(false), isProcessingTransaction = _o[0], setIsProcessingTransaction = _o[1];
    var _p = useState(false), isTebraPayFacPassThroughOnly = _p[0], setIsTebraPayFacPassThroughOnly = _p[1];
    var handleChangePaymentMethod = useCallback(function (event) {
        setSelectedPaymentMethod(event.target.value);
        if (event.target.value !== 'credit') {
            setPreventCreditCharge(true);
        }
    }, [setSelectedPaymentMethod]);
    var handleChangePreventCreditCharge = useCallback(function (event) {
        setPreventCreditCharge(event.target.checked);
    }, [setPreventCreditCharge]);
    useEffect(function () {
        featureToggles
            .isEnabled(FeatureToggles.TEBRA_PAYFAC_PASS_THROUGH_ONLY)
            .then(function (response) {
            setIsTebraPayFacPassThroughOnly(!!response);
        });
    }, []);
    var resetBillingAddress = useCallback(function () {
        setBillingAddressSameAsPatientAddress(true);
        setBillingAddress1(address1);
        setBillingZip(zip);
        setName(name);
    }, [address1, zip, name]);
    var handleChangeBillingAddressSame = useCallback(function (event) {
        var checked = event.target.checked;
        if (checked) {
            resetBillingAddress();
        }
        setBillingAddressSameAsPatientAddress(checked);
    }, [setBillingAddressSameAsPatientAddress, resetBillingAddress]);
    var transactionOptions = useMemo(function () {
        var address = typeof billingAddress1 === 'string' ? billingAddress1 : '';
        var zip = typeof billingZip === 'string' ? billingZip : '';
        var charge = typeof amount === 'string' ? amount : '0.00';
        return {
            amount: formatAmount(charge),
            billingAddress1: address !== null && address !== void 0 ? address : '',
            billingZipcode: zip !== null && zip !== void 0 ? zip : '',
            cardAccountId: patient.patientId,
            name: name !== null && name !== void 0 ? name : '',
            paymentType: isCheckedSaveCard ? 4 : undefined,
            saveCard: isCheckedSaveCard || false,
            submissionType: isCheckedSaveCard ? 1 : undefined,
            metadata: {
                note: note,
                patientId: patient.patientId,
                userGuid: user.userGuid,
                paymentScenario: 'webapp',
            },
        };
    }, [amount, billingAddress1, billingZip, isCheckedSaveCard, error]);
    function onClickProcessTransaction() {
        // is there a smarter way to determine which path to process payment
        if (selectedTerminal !== null) {
            return handleProcessTerminalPayment();
        }
        if (selectedCard !== null) {
            return handleProcessSavedCardPayment();
        }
    }
    // TODO: https://kareodev.atlassian.net/browse/PAY-3956
    function handleProcessTerminalPayment() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (selectedTerminal === null)
                    return [2 /*return*/];
                setIsProcessingTransaction(true);
                setError(undefined);
                return [2 /*return*/];
            });
        });
    }
    function handleProcessSavedCardPayment() {
        return __awaiter(this, void 0, void 0, function () {
            var options, cofTransactionURL, transactionResp, recordResp, err_1, errorCOF;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (selectedCard === null)
                            return [2 /*return*/];
                        setIsProcessingTransaction(true);
                        setError(undefined);
                        options = {
                            amount: formatAmount(amount),
                            applicationId: portal.AppId,
                            cardId: selectedCard.cardId,
                            cardAccountId: patient.patientId,
                            name: patient.name,
                            patientId: patient.patientId,
                            paymentType: 4,
                            practiceExternalId: (practice.customerId || practice.practiceGuid).toString(),
                            submissionType: 2,
                            isExternalId: true,
                            metadata: {
                                note: note,
                                patientId: patient.patientId,
                                userGuid: user.userGuid,
                                paymentScenario: 'webapp',
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        cofTransactionURL = isTebraPayFacPassThroughOnly
                            ? '/payments-ui/api/PatientPay/payments-orchestrator-service/api/transactions/chargecard'
                            : "/payments-ui/api/PatientPay/transactions/cards/" + (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId);
                        return [4 /*yield*/, kfetch(cofTransactionURL, {
                                method: 'POST',
                                body: JSON.stringify(options),
                            })];
                    case 2:
                        transactionResp = _a.sent();
                        return [4 /*yield*/, kfetch('/payments-ui/api/PatientPayment/hosted-payments', {
                                method: 'POST',
                                body: JSON.stringify({
                                    cardInHand: false,
                                    paymentFacilitationType: 'hosted-platform-payment',
                                    referenceId: transactionResp.referenceId,
                                    amount: formatAmount(isTebraPayFacPassThroughOnly
                                        ? transactionResp.approvedAmount
                                        : transactionResp.amount),
                                    patientId: patient.patientId,
                                    note: note,
                                }),
                            }).catch(function () {
                                // this is to differentiate from `/transactions` errors
                                //  in https://kareodev.atlassian.net/browse/PAY-2304 we will continue
                                //  to the receipt page even if this has an error
                                return new Error('POSTED_PAYMENTS_ERROR');
                            })];
                    case 3:
                        recordResp = _a.sent();
                        props.onConfirmTransactionCOF(transactionResp, recordResp);
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        rollbar.error(err_1);
                        errorCOF = new Error('Payment could not be processed. Try using a different card if this error persists.');
                        setError(errorCOF);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsProcessingTransaction(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    var isSubmitDisabled = !Boolean(amount) || Number(amount) === 0;
    return (React.createElement(Card, null,
        React.createElement(CardContent, null,
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h3" }, "Collect Payment"),
                React.createElement(Form, { noValidate: true, autoComplete: "off" },
                    React.createElement(Box, { display: "block" },
                        React.createElement(FeatureToggle, { if: "dark-feature.tebra-payfac-amount-formatting" },
                            React.createElement(TextField, { "data-testid": "collect-payment-amount", value: pendingAmount, label: "Amount", type: "text", margin: "dense", inputProps: {
                                    inputMode: 'decimal',
                                }, onChange: function (e) {
                                    setPendingAmount(e.target.value);
                                }, onBlur: function () {
                                    var newAmount = formatAmount(pendingAmount);
                                    setPendingAmount(newAmount);
                                    setAmount(newAmount);
                                } })),
                        React.createElement(FeatureToggle, { if: "!dark-feature.tebra-payfac-amount-formatting" },
                            React.createElement(TextField, { value: pendingAmount, label: "Amount", type: "text", margin: "dense", inputProps: {
                                    inputMode: 'decimal',
                                }, onChange: function (e) {
                                    setPendingAmount(e.target.value);
                                }, onBlur: function () {
                                    var amountString = Number(pendingAmount !== null && pendingAmount !== void 0 ? pendingAmount : 0).toFixed(2);
                                    var newAmount = isNaN(Number(amountString))
                                        ? '0.00'
                                        : amountString;
                                    setPendingAmount(newAmount);
                                    setAmount(Number(newAmount).toString());
                                } }))),
                    React.createElement(Box, { display: "block" },
                        !showingNote && (React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () { return setShowingNote(true); } }, "Add Payment Note")),
                        showingNote && (React.createElement(Box, null,
                            React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start" },
                                React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () {
                                        onUpdateNote('');
                                        setShowingNote(false);
                                    } }, "Remove Note"),
                                React.createElement(NoteTextArea, { multiline: true, value: note, onChange: function (event) {
                                        var value = event.target.value;
                                        setNote(value);
                                        onUpdateNote(value);
                                    } }),
                                React.createElement(Typography, { variant: "caption" }, "This note is only visible to the practice.")))))))),
        React.createElement(CardDivider, null),
        React.createElement(CardContent, null,
            React.createElement(Typography, { variant: "h3" }, "Payment Method"),
            React.createElement(FormControl, { component: "fieldset" },
                React.createElement(RadioGroup, { row: true, "aria-label": "selected-payment-method", name: "selectedPaymentMethod", value: selectedPaymentMethod, onChange: handleChangePaymentMethod },
                    React.createElement(FormControlLabel, { labelPlacement: "end", value: "credit", control: React.createElement(Radio, null), label: "Credit Card" }),
                    React.createElement(FormControlLabel, { labelPlacement: "end", value: "cash", control: React.createElement(Radio, null), label: "Cash" }),
                    React.createElement(FormControlLabel, { labelPlacement: "end", value: "check", control: React.createElement(Radio, null), label: "Check" })),
                selectedPaymentMethod === 'credit' && (React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: preventCreditCharge, onChange: handleChangePreventCreditCharge }), label: "Do not charge credit card. For recording purposes only." })))))),
        React.createElement(CardDivider, null),
        React.createElement(CardContent, null,
            React.createElement(Typography, { variant: "h3" }, "Billing Address"),
            React.createElement(React.Fragment, null,
                React.createElement(FormGroup, null,
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: billingAddressSameAsPatientAddress, onChange: handleChangeBillingAddressSame }), label: "Billing address is same as patient address" })),
                !billingAddressSameAsPatientAddress && (React.createElement(BillingAddressForm, null,
                    React.createElement(TextField, { margin: "dense", label: "Address", defaultValue: address1 }),
                    React.createElement(TextField, { margin: "dense", label: "Zip", defaultValue: zip, inputProps: { maxLength: 5 } }))))),
        React.createElement(CardDivider, null),
        !preventCreditCharge && (React.createElement(CardDetailsSection, { error: error, setError: setError, onClickProcessTransaction: onClickProcessTransaction, transactionOptions: transactionOptions, isCheckedSaveCard: isCheckedSaveCard, setIsCheckedSaveCard: setIsCheckedSaveCard, isProcessingTransaction: isProcessingTransaction, isSubmitDisabled: isSubmitDisabled })),
        preventCreditCharge && (React.createElement(CardContent, null,
            React.createElement(Box, null,
                React.createElement(Button, { color: "vitality", disabled: isSubmitDisabled, onClick: function () {
                        return onFinalizePayment({
                            amount: amount,
                            paymentMethod: selectedPaymentMethod,
                            note: note,
                        });
                    } }, "Finalize Payment")))),
        React.createElement(CardContent, { style: { paddingTop: 0 } },
            !!error && (React.createElement(Box, { marginBottom: 2 },
                React.createElement(Alert, { severity: "error" }, error === null || error === void 0 ? void 0 : error.message))),
            React.createElement(Alert, { severity: "info" }, "Important: It may take up to 15 minutes for the transaction to appear on the transactions table. Please do not retry processing the transaction after clicking 'Process Transaction' once. Multiple attempts may result in multiple charges to your customers."))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
